import React from 'react'
import StrategyTemplate from '../../templates/Strategy/StrategyTemplate'

const Strategy = () => {
  return (
     <StrategyTemplate />
  )
}

export default Strategy